const data = [
  // {
  //   name: "Início",
  //   path: null,
  //   children: [
  //    { name: "Credores", icon: "mdi-account-group-outline", route: "/usuarios", path: "User" },
  //   ],
  // },
  {
    name: "Gestão",
    path: "Manager",
    children: [
      { name: "Adesão ao Plano", icon: "mdi-file-sign", route: "/adesao-plano", path: "PlanAdherence" },
      { name: "Análise de Ofício", icon: "mdi-file-search-outline", route: "/analise-oficio", path: "OfficioAnalysis" },
      { name: "Hab/Div", icon: "mdi-sync-alert", route: "/divergencias", path: "Event" },
      { name: "Revisão de Crédito", icon: "mdi-file-document-refresh-outline", route: "/revisao-credito", path: "Objection" },
      { name: "Comprovantes de Pagamento", icon: "mdi-receipt-text-check-outline", route: "/comprovantes-pagamento", path: "PaymentProof" },
      { name: "Certidões de Habilitação", icon: "mdi-file-certificate-outline", route: "/certidoes-habilitacao", path: "CreditCertificate" },
      { name: "QGC", icon: "mdi-card-account-details-outline", route: "/qgc", path: "Qgc" },
      { name: "Solicitação de Documentos", icon: "mdi-account-file-outline", route: "/solicitacao-documentos", path: "Client" },
     // { name: "Credores", icon: "mdi-account-group-outline", route: "/credores", path: "User" },
    ],
  },
];

export default [...data];
